import React from 'react';
import QualitiesPrice from './QualitiesPrice';
import RequiredProxyInput from 'components/elements/RequiredProxyInput';
import useStores from 'utils/useStores';
import { observer } from 'mobx-react';

export interface QualitiesPricesProps {
  // PLA-1099: el modelo exige al menos una calidad (validates :fixed_price_contracts_qualities,
  // presence: true). Son checkboxes sueltos, así que no participan de la validación nativa del
  // navegador por sí solos.
  required?: boolean;
}

const QualitiesPrices = ({ required = false }: QualitiesPricesProps) => {
  const { qualitiesPricesStore } = useStores();

  const anyChecked = qualitiesPricesStore.checkableQualitiesPrices.some(
    (qualitiesPrice) => qualitiesPrice.checked
  );

  return (
    // `position: relative` ancla el testigo de RequiredProxyInput. El <div> envuelve la tabla
    // porque un <input> no es hijo válido de <table>.
    <div style={{ position: 'relative' }}>
      <table data-cy='qualities_prices'>
        <thead>
          <tr>
            <td></td>
            <td>{I18n.translate('attributes.quality')}</td>
            <td>{I18n.translate('attributes.cup_premium')}</td>
          </tr>
        </thead>

        <tbody>
          {qualitiesPricesStore.checkableQualitiesPrices.map((qualitiesPrice, index) => (
            <QualitiesPrice key={index} qualitiesPrice={qualitiesPrice} />
          ))}
        </tbody>
      </table>

      {required && <RequiredProxyInput filled={anyChecked} />}
    </div>
  );
};

export default observer(QualitiesPrices);
